import EmailValidator from 'email-validator';

export default function validate(values) {
    let errors = {};

    if(!values.password) {
        errors.password = 'missingPassword'
    }

    if(!values.firstName) {
        errors.firstName = 'missingFirstName'
    }

    if(!values.lastName) {
        errors.lastName = 'missingLastName'
    }

    return errors;
}
